import { Link } from 'react-router-dom'
import { Button, TableContainer, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

const OpenExamTable = ({examinations}) => {
  return (
    <TableContainer component="table">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Section</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>End Date</TableCell>
          <TableCell>Attempts</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {examinations?.length <= 0 && <>
          <TableRow>
            <TableCell colSpan={6} style={{textAlign: 'center', fontStyle: 'italic'}}>No Open Examinations</TableCell>
          </TableRow>
        </>}
        {examinations?.length > 0 && examinations.map((e) => (
          <TableRow key={e.examination.name}>
            <TableCell>{e.examination.name}</TableCell>
            <TableCell>{e.classroom.name} - {e.classroom.section}</TableCell>
            <TableCell>
              {e.examination.start}
            </TableCell>
            <TableCell>
              {e.examination.end}
            </TableCell>
            <TableCell>
              <Link to={`examinations/${e.examination.id}/attempts`} style={{color: '#EF6527'}}>{e.number_of_attempts}/{e.examination.max_attempt}</Link>
            </TableCell>
            <TableCell>
              <Link to={`/examinations/${e.examination.id}/form`}>
                <Button size="small" variant="contained" color="secondary" disableElevation>
                  <i className="fa fa-eye"></i> &nbsp;
                  View
                </Button>
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  )
}

export default OpenExamTable